// import { IRequestApartments } from '@interfaces/apartments/IApartments'
import { string, object, array, ObjectSchema } from 'yup'

export interface IRequestApartments {
    realEstateId: string
    number: string
    userId: string
    filesData: {
        name: string
        type: string
    }[]
}

const apartmentSchema = new ObjectSchema({
    realEstateId: string().notOneOf(['none'], 'Selecione o imóvel').required('Selecione o imóvel'),
    number: string().required('Adicione o número do apartamento'),
    userId: string().notOneOf(['none'], 'Selecione o nome do proprietário').required('Selecione o nome do proprietário'),
    filesData: array().of(
        object().shape({
            name: string().required('Adicione o nome do arquivo'),
            type: string().required('Selecione a categoria do arquivo'),
        })
    ),
})

export default apartmentSchema
